import React from "react";
import "./defaultPlaceHolder.css";

export const DefaultPlaceHolder = ({ placeHolder }) => {
  return <div className="about-placeholder">{placeHolder}</div>;
};
